(function () {
  const root = document.querySelector('[data-policy-page]');
  if (!root) return;

  const getHeaderHeight = () => {
    const header = document.querySelector('.site-header');
    return header ? header.getBoundingClientRect().height : 0;
  };

  const getAnchorNode = (target) => {
    if (!target) return null;
    if (target.tagName === 'DETAILS') {
      return target.querySelector('[data-policy-summary]') || target;
    }
    if (target.classList.contains('policy-group')) {
      return target.querySelector('[data-policy-group-title]') || target;
    }
    const detailsParent = target.closest('details');
    if (detailsParent) {
      return detailsParent.querySelector('[data-policy-summary]') || target;
    }
    return target;
  };

  const centerTargetInViewport = (node, smooth) => {
    if (!node) return;

    const headerHeight = getHeaderHeight();
    const rect = node.getBoundingClientRect();
    const usableViewport = window.innerHeight - headerHeight;
    const targetTop = window.scrollY + rect.top - headerHeight - (usableViewport - rect.height) / 2;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: smooth ? 'smooth' : 'auto'
    });
  };

  const focusHashTarget = (smooth) => {
    const hash = window.location.hash ? decodeURIComponent(window.location.hash.slice(1)) : '';
    if (!hash) return;

    const target = document.getElementById(hash);
    if (!target || !root.contains(target)) return;

    if (target.tagName === 'DETAILS') {
      target.open = true;
    } else {
      const detailsParent = target.closest('details');
      if (detailsParent) detailsParent.open = true;
    }

    const anchorNode = getAnchorNode(target);
    requestAnimationFrame(() => {
      centerTargetInViewport(anchorNode, smooth);
    });
  };

  root.querySelectorAll('[data-policy-summary]').forEach((summary) => {
    summary.addEventListener('click', () => {
      const item = summary.closest('[data-policy-item]');
      if (!item || !item.id) return;
      window.history.replaceState(null, '', `#${item.id}`);
    });
  });

  window.addEventListener('hashchange', () => focusHashTarget(true));
  window.addEventListener('load', () => focusHashTarget(false));
})();
